export const SELECT_IMAGE = 'SELECT_IMAGE'
export const PRODUCT_STATUS_UPDATED = 'PRODUCT_STATUS_UPDATED'
export const OPEN_PRODUCT_APPROVAL_DIALOG = 'OPEN_PRODUCT_APPROVAL_DIALOG'
export const CLOSE_PRODUCT_APPROVAL_DIALOG = 'CLOSE_PRODUCT_APPROVAL_DIALOG'
export const PRODUCT_UPDATE_ERROR = 'PRODUCT_UPDATE_ERROR'